import $ from "./_common.js";
import M from "../../_styles/common/light.js";
import { changeColor as o } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function L(i) {
  const {
    textColor2: a,
    primaryColorHover: t,
    primaryColorPressed: C,
    primaryColor: r,
    infoColor: e,
    successColor: l,
    warningColor: c,
    errorColor: s,
    baseColor: d,
    borderColor: h,
    opacityDisabled: p,
    tagColor: m,
    closeIconColor: g,
    closeIconColorHover: I,
    closeIconColorPressed: P,
    borderRadiusSmall: n,
    fontSizeMini: f,
    fontSizeTiny: b,
    fontSizeSmall: S,
    fontSizeMedium: u,
    heightMini: x,
    heightTiny: v,
    heightSmall: y,
    heightMedium: H,
    closeColorHover: k,
    closeColorPressed: W,
    buttonColor2Hover: E,
    buttonColor2Pressed: z,
    fontWeightStrong: B
  } = i;
  return Object.assign(Object.assign({}, $), {
    closeBorderRadius: n,
    heightTiny: x,
    heightSmall: v,
    heightMedium: y,
    heightLarge: H,
    borderRadius: n,
    opacityDisabled: p,
    fontSizeTiny: f,
    fontSizeSmall: b,
    fontSizeMedium: S,
    fontSizeLarge: u,
    fontWeightStrong: B,
    // checked
    textColorCheckable: a,
    textColorHoverCheckable: a,
    textColorPressedCheckable: a,
    textColorChecked: d,
    colorCheckable: "#0000",
    colorHoverCheckable: E,
    colorPressedCheckable: z,
    colorChecked: r,
    colorCheckedHover: t,
    colorCheckedPressed: C,
    // default
    border: `1px solid ${h}`,
    textColor: a,
    color: m,
    colorBordered: "rgb(250, 250, 252)",
    closeIconColor: g,
    closeIconColorHover: I,
    closeIconColorPressed: P,
    closeColorHover: k,
    closeColorPressed: W,
    borderPrimary: `1px solid ${o(r, {
      alpha: 0.3
    })}`,
    textColorPrimary: r,
    colorPrimary: o(r, {
      alpha: 0.12
    }),
    colorBorderedPrimary: o(r, {
      alpha: 0.1
    }),
    closeIconColorPrimary: r,
    closeIconColorHoverPrimary: r,
    closeIconColorPressedPrimary: r,
    closeColorHoverPrimary: o(r, {
      alpha: 0.12
    }),
    closeColorPressedPrimary: o(r, {
      alpha: 0.18
    }),
    borderInfo: `1px solid ${o(e, {
      alpha: 0.3
    })}`,
    textColorInfo: e,
    colorInfo: o(e, {
      alpha: 0.12
    }),
    colorBorderedInfo: o(e, {
      alpha: 0.1
    }),
    closeIconColorInfo: e,
    closeIconColorHoverInfo: e,
    closeIconColorPressedInfo: e,
    closeColorHoverInfo: o(e, {
      alpha: 0.12
    }),
    closeColorPressedInfo: o(e, {
      alpha: 0.18
    }),
    borderSuccess: `1px solid ${o(l, {
      alpha: 0.3
    })}`,
    textColorSuccess: l,
    colorSuccess: o(l, {
      alpha: 0.12
    }),
    colorBorderedSuccess: o(l, {
      alpha: 0.1
    }),
    closeIconColorSuccess: l,
    closeIconColorHoverSuccess: l,
    closeIconColorPressedSuccess: l,
    closeColorHoverSuccess: o(l, {
      alpha: 0.12
    }),
    closeColorPressedSuccess: o(l, {
      alpha: 0.18
    }),
    borderWarning: `1px solid ${o(c, {
      alpha: 0.35
    })}`,
    textColorWarning: c,
    colorWarning: o(c, {
      alpha: 0.15
    }),
    colorBorderedWarning: o(c, {
      alpha: 0.12
    }),
    closeIconColorWarning: c,
    closeIconColorHoverWarning: c,
    closeIconColorPressedWarning: c,
    closeColorHoverWarning: o(c, {
      alpha: 0.12
    }),
    closeColorPressedWarning: o(c, {
      alpha: 0.18
    }),
    borderError: `1px solid ${o(s, {
      alpha: 0.23
    })}`,
    textColorError: s,
    colorError: o(s, {
      alpha: 0.1
    }),
    colorBorderedError: o(s, {
      alpha: 0.08
    }),
    closeIconColorError: s,
    closeIconColorHoverError: s,
    closeIconColorPressedError: s,
    closeColorHoverError: o(s, {
      alpha: 0.12
    }),
    closeColorPressedError: o(s, {
      alpha: 0.18
    })
  });
}
const T = {
  name: "Tag",
  common: M,
  self: L
}, w = T;
export {
  w as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/tag/styles/light.js
// module id = 1707
// module chunks = 41